export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11371.5f096ca3.jpg";